import PaymentForm from 'components/PaymentForm';
import Text from 'components/Text';
import { TEXT_STRING } from '../../constants';
import { useCallback } from 'react';
import { EPaymentMethod, TPaymentPayload } from 'types';
import { getFormattedAmount } from 'utils';
import { useToast } from 'hooks';

type Props = {
  title?: string;
  paying: boolean;
  price?: number;
  onPay: (payload: TPaymentPayload) => Promise<void>;
  subTitle?: string;
  onSettled?: () => void;
  onCancel?: () => void;
};

const CardPayment = ({
  title = TEXT_STRING.PAYMENT.PAYMENT_METHOD,
  paying,
  price,
  onPay,
  subTitle = TEXT_STRING.CALL_WOMAN.PAYMENT_WARNING,
  onSettled,
  onCancel,
}: Props) => {
  // Hooks
  const { toastError } = useToast();

  // Memo, callbacks
  const handlePaymentCard = useCallback(
    async (payload: TPaymentPayload) => {
      try {
        await onPay(payload);
      } catch (error) {
        toastError(error as Error);
      } finally {
        onSettled && onSettled();
      }
    },
    [onPay, onSettled, toastError],
  );

  return (
    <>
      {title && (
        <Text className="text-3xl py-6" center bold>
          {title}
        </Text>
      )}
      <Text className="text-3xl pb-5" center bold>
        {getFormattedAmount(price)}
        {TEXT_STRING.COMMON.YEN}
      </Text>
      <Text center fontSize={14}>
        {subTitle}
      </Text>
      <PaymentForm
        submitAction={{
          action: (token, customerId) =>
            handlePaymentCard({
              token,
              customerId,
              type: EPaymentMethod.VISA,
            }),
          loading: paying,
          disabled: paying,
        }}
        onCancel={onCancel}
      />
    </>
  );
};

export default CardPayment;
